import React from "react";
import founder1 from "../assets/img/dr sid pic.jpg";
import founder2 from "../assets/img/sudhanshu image.jpg";
import Sd1 from '../assets/dheeraj-Lenovo.jpeg';
import TeamSection from "./TeamSection";
import Ravi from '../assets/RAvi.png';
import img5 from '../assets/monu.png';
const people = [
  {
    id: 1,
    name: "Sudhanshu Sharma",
    role: "FOUNDING DIRECTOR & CTO  ",
    image: founder2,
//     bio: `Write about the founder here. Their background, experience, vision,
// and how they started the company. Keep it 3–5 lines for a clean look.`,
    align: "left",
  },
  {
    id: 2,
    name: "Dr. Siddharth Sharma",
    role: "FOUNDING DIRECTOR & CEO",
    image: founder1,
//     bio: `Write about the co-founder here. Mention achievements, expertise,
// and contribution to building the product/team.`,
    align: "right",
  },
   {
    id: 3,
    name: "Dheeraj mishra",
    role: "Software developer",
    image: Sd1,
    // bio: `Led scalable software development, delivering robust architecture, cross-functional collaboration, technical excellence, and measurable contributions to product maturity and team growth.`,
     align: "right",
  },
  {
    id: 3,
    name: "Ravi Kumar ",
    role: "Embedded Engineer",
    image: Ravi,
//     bio: `Write about the co-founder here. Mention achievements, expertise,
// and contribution to building the product/team.`,
    align: "right",
  }, 
//   {
//     id: 4,
//     name: "Monu Mourya ",
//     role: "Embedded Engineer",
//     image: img5,
// //     bio: `Write about the co-founder here. Mention achievements, expertise,
// // and contribution to building the product/team.`,
//     align: "right",
//   },
];

const FounderCard = ({ person }) => {
  const isLeft = person.align === "left";

  return (
    <section className="founder-section">
      {/* Image */}
      <div
        className="founder-media"
        style={{ order: isLeft ? 0 : 1 }}
      >
        <div className="founder-mediaInner">
          <img
            src={person.image}
            alt={person.name}
            className="founder-img"
          />
        </div>
      </div>

      {/* Text */}
      <div
        className="founder-text"
        style={{ order: isLeft ? 1 : 0 }}
      >
        <div className="founder-chip">{person.role}</div>

        <h2 className="founder-name">{person.name}</h2>

        <p className="founder-bio">{person.bio}</p>

        <div className="founder-actions">
          {/* <a className="founder-btn ghost" href="/">View Profile</a> */}
          {/* <a className="founder-btn solid" href="/">Contact</a> */}
        </div>
      </div>

      {/* CSS */}
      <style>{`
        .founder-section{
          display: grid;
          grid-template-columns: 460px 1fr;
          gap: 24px;
          align-items: center;
          padding: 32px 0;
        }

        .founder-media{
          border-radius: 16px;
          overflow: hidden;
          background: #f4f5f7;
          box-shadow: 0 8px 24px rgba(0,0,0,0.08);
        }

        /* ✅ HEIGHT CONTROL HERE */
        .founder-mediaInner{
          width: 100%;
          height: 340px;        /* desktop */
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f3f4f6;
        }

        .founder-img{
          max-width: 100%;
          max-height: 100%;
          object-fit: contain; /* ✅ NO CUT */
        }

        .founder-chip{
          display: inline-block;
          padding: 6px 14px;
          font-size: 13px;
          border-radius: 999px;
          background: rgba(0,0,0,0.06);
          margin-bottom: 12px;
        }

        .founder-name{
          font-size: 30px;
          margin: 6px 0 10px;
          line-height: 1.1;
        }

        .founder-bio{
          font-size: 16px;
          line-height: 1.7;
          color: #333;
          max-width: 60ch;
        }

        .founder-actions{
          margin-top: 16px;
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .founder-btn{
          padding: 10px 16px;
          border-radius: 12px;
          font-size: 14px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .founder-btn.ghost{
          border: 1px solid rgba(0,0,0,0.18);
          color: #111;
        }

        .founder-btn.solid{
          background: #111;
          color: #fff;
          border: 1px solid #111;
        }

        /* ✅ 1100px */
        @media (max-width: 1100px){
          .founder-section{
            grid-template-columns: 380px 1fr;
          }
          .founder-mediaInner{
            height: 300px;
          }
        }

        /* ✅ Tablet */
        @media (max-width: 900px){
          .founder-section{
            grid-template-columns: 1fr;
          }
          .founder-section > div{
            order: initial !important;
          }
          .founder-mediaInner{
            height: 260px;
          }
        }

        /* ✅ Mobile */
        @media (max-width: 600px){
          .founder-mediaInner{
            height: 220px;
          }
          .founder-name{
            font-size: 24px;
          }
        }
      `}</style>
    </section>
  );
};

export default function MUEFoundersPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #fafafa 0%, #ffffff 100%)",
        fontFamily:
          "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
      }}
    >
      {/* Header */}
      <header style={{ padding: "48px 16px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <h1 style={{ fontSize: 40, margin: 0 }}>Founder & Leadership</h1>
          <p style={{ marginTop: 10, maxWidth: 720, color: "#444" }}>
            Profiles of founders, core R&D team, advisors, and mentors highlighting
            clinical and engineering expertise.
          </p>
        </div>
      </header>

      {/* Content */}
      <main style={{ padding: "0 16px 60px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          {people.map((p) => (
            <div key={p.id}>
              <FounderCard person={p} />
              <div
                style={{
                  height: 1,
                  background: "rgba(0,0,0,0.08)",
                  margin: "16px 0",
                }}
              />
            </div>
          ))}
        </div>
      </main>
   
    </div>
  );
}
